.grid-settings {
  &--title {
    margin: 0 0 calc(var(--spacer) * 2);
    line-height: 1;
    padding: var(--spacer) 0;
  }

  &--container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--white-layout-302-level-1-elevation);
  }
  &--header {
    padding: 52px calc(var(--spacer) * 3) 0;
  }
  &--content {
    padding: 0 calc(var(--spacer) * 2);
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  &--footer {
    padding: 10px calc(var(--spacer) * 3);
  }
}

gz-checkbox {
  --font-size: var(--body-size-large);
}

.grid-columns {
  &--toggle-view {
    --font-family: var(--font-family-secondary);
    padding: 0 var(--spacer);
  }
}

#list-content {
  flex: 1;
  overflow: auto;
}

gz-enum-list::part(listOptions) {
  background: var(--background-transparent);
}
